import { Trans } from '@lingui/react/macro';

import type { OpportunityStatusType, OpportunityType } from '@/api/opportunity';
import { ColorBadge } from '@/components/typography';
import { CLOSED_LOST_PRIMARY, CLOSED_WON_PRIMARY, PIPELINE_PRIMARY } from '@/constants';

type Props = {
  opportunity?: OpportunityType;
  status?: OpportunityStatusType;
};

const OpportunityStatusTag = ({ opportunity, status }: Props) => {
  const opportunityStatus = status ?? opportunity?.status;

  if (opportunityStatus === 'CLOSED_WON') {
    return (
      <ColorBadge size="medium" color={CLOSED_WON_PRIMARY} textColor="light" showTooltip={false}>
        <Trans>Closed Won</Trans>
      </ColorBadge>
    );
  }

  if (opportunityStatus === 'CLOSED_LOST') {
    return (
      <ColorBadge size="medium" color={CLOSED_LOST_PRIMARY} textColor="light" showTooltip={false}>
        <Trans>Closed Lost</Trans>
      </ColorBadge>
    );
  }

  if (opportunityStatus === 'PIPELINE') {
    return (
      <ColorBadge size="medium" color={PIPELINE_PRIMARY} textColor="light" showTooltip={false}>
        <Trans>Open</Trans>
      </ColorBadge>
    );
  }

  return null;
};

export default OpportunityStatusTag;
